import React, { useEffect, useState } from 'react'
import './passwordStrength.css'
import zxcvbn from 'zxcvbn'

const PasswordStrengthMeter = (props) => {
    const { data, field } = props
    const [score, setScore] = useState(false)

    const createPasswordLabel = (result) => {
        //

        switch (result.score) {
            case 0:
                return 'Weak'
            case 1:
                return 'Weak'
            case 2:
                return 'Fair'
            case 3:
                return 'Good'
            case 4:
                return 'Strong'
            default:
                return 'Weak'
        }
    }

    useEffect(() => {
        setScore(zxcvbn(data.formik.values[field]))
    }, [data.formik.values[field]])

    useEffect(() => {
        if (score) {
            data.formik.setFieldValue(data.name, parseInt(score.score))
        }
    }, [score])

    return (
        <div className="password-strength-meter">
            {data.formik.values[field] && (
                <>
                    <label className="password-strength-meter-label">
                        <strong>Password strength: </strong>
                        {createPasswordLabel(score)}
                    </label>
                    <div>
                        <progress
                            className={`password-strength-meter-progress strength-${createPasswordLabel(
                                score,
                            )}`}
                            value={score.score}
                            max="4"
                        />
                        {data.formik.errors[data.name] ? (
                            <p className="scheduleError">
                                {data.hideMessage ? null : data.formik.errors[data.name]}
                            </p>
                        ) : null}
                    </div>
                    <br />
                </>
            )}
        </div>
    )
}

export default PasswordStrengthMeter
